import { defineMessages } from "react-intl";

import { node as bloodGroup } from "src/modules/ltx/forms/phase-i/bloodGroup";
import { node as consultations } from "src/modules/ltx/forms/phase-i/consultations";
import { node as cultures } from "src/modules/ltx/forms/phase-i/cultures";
import { node as imagingProcedures } from "src/modules/ltx/forms/phase-i/imaging-procedures";
import { node as labProcedures } from "src/modules/ltx/forms/phase-i/lab-procedures";
import { node as medicalHistory } from "src/modules/ltx/forms/phase-i/medical-history";
import { node as vaccinationStatus } from "src/modules/ltx/forms/phase-i/vaccinationStatus";
import { node as viralSerology } from "src/modules/ltx/forms/phase-i/viral-serology";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.phase_i",
		defaultMessage: "Fázis I"
	}
});

export const node: ParentNode = {
	id: "phaseI",
	value: { type: "wizard", title: messages.title },
	children: [
		bloodGroup,
		vaccinationStatus,
		medicalHistory,
		labProcedures,
		viralSerology,
		cultures,
		imagingProcedures,
		consultations
	]
};
